import { db } from '@react-native-firebase/database';
import StyleSheetRW from 'core/StyleSheetRW';
import { get, push, ref, remove, set } from "firebase/database";
import { useEffect, useRef, useState } from 'react';
import { BsFilePdf } from 'react-icons/bs';
import { Dimensions, Modal, ScrollView, Text, TextInput, View, } from 'react-native';
import { MOBILE_VIEW_WIDTH } from 'res/constants';
import Dialog from 'src/components/Dialog';
import Loader from 'src/components/Loader';
import { AddCandidateForm } from './AddCandidateForm';
import { BsPenFill } from 'react-icons/bs';
import { BsTrashFill } from 'react-icons/bs';
import { BsTrash2Fill } from 'react-icons/bs';
import Menu from './Menu';
import { formatDate } from 'src/utils/Date&TimeUtils';
import closeIcon from "res/img/cross.png";
import DropDownField from 'src/components/DropDownField';


interface RecruitmentData {
  id: string;
  name: string;
  email: string;
  fileUrl: string;
  fileName: string;
  currentSalary?: number;
  expectedSalary?: number;
  availability?: string;
  otherDetails?: string;
  experience?: number;
  feedback?: number;
}

const RecruitmentScreen = () => {

  const [isVisible, setIsVisible] = useState(false);
  const [feedback, setFeedback] = useState('');
  const [currentCandidateId, setCurrentCandidateId] = useState(null);
  const [toastMessage, setToastMessage] = useState("");
  const [dilogueMessage, setDilogueMessage] = useState("");
  const [showToast, setShowToast] = useState(false);
  const [showDilogue, setShowDilogue] = useState(false);
  const [currentFeedbacks, setCurrentFeedbacks] = useState([]);
  const [viewFeedbackModalVisibal, setViewFeedbackModalVisibal] = useState(false)
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const screenWidth = Dimensions.get('window').width;
  const [showLoader, setShowLoader] = useState(false);
  const [candidates, setCandidates] = useState<RecruitmentData[]>([]);
  const [filteredCandidates, setFilteredCandidates] = useState<RecruitmentData[]>([]);
  const [showFliterModel, setShowFliterModel] = useState<boolean>(false);
  const [confirmDilogeVisibal,setConfirmDilogueVisibal]=useState(false)
  const [feedbackDate,setFeedbackDate]=useState("")
  const[feedbackID,setFeedbackId]=useState("")
  const [filters, setFilters] = useState({
    experience: '',
    currentSalaryMin: '',
    currentSalaryMax: ''
  });
  const [userList, setUserList] = useState<any>([]);
  const [selectedEmployee, setSelectedEmployee] = useState<any>("");

  const fetchCandidates = async () => {
    setShowLoader(true);
    try {
      const dbRef = ref(db, `recruitment`);
      await get(dbRef).then((snapshot) => {
        if (snapshot.exists()) {
          const candidatesFetchedData = snapshot.val();
          const usersArray = Object.keys(candidatesFetchedData).map(key => ({
            id: key,
            ...candidatesFetchedData[key],
          }));
          const reversedCandidatesArray=usersArray.reverse()
          setCandidates(reversedCandidatesArray);
          setFilteredCandidates(reversedCandidatesArray);
        }
        setShowLoader(false);
      });
    } catch {
      setShowLoader(false);
    }
  };

  useEffect(() => {
    fetchCandidates();
    fetchUsersNameData()
  }, []);

  const handleInputChange = (e: any) => {
    const { name, value } = e.target;
    setFilters({
      ...filters,
      [name]: value
    });
  };

  const onCandidateFormSubmit=()=>
    {
      setEditMode(false)
      setOpenForm(false)
      fetchCandidates()
    }

    const onCandidateFormClose=()=>
      {
        setOpenForm(false)
        setEditMode(false)
      }
  const handleApplyFilters = () => {
    const { experience, currentSalaryMin, currentSalaryMax } = filters;
    const filtered = candidates.filter(candidate => {
      return (
        (experience === '' || candidate.experience >= parseInt(experience)) &&
        (currentSalaryMin === '' || candidate.currentSalary >= parseInt(currentSalaryMin)) &&
        (currentSalaryMax === '' || candidate.currentSalary <= parseInt(currentSalaryMax))
      );
    });
    setFilteredCandidates(filtered);
  };

  const [openForm, setOpenForm] = useState(false)
  const [editMode,setEditMode]=useState(false)
  const [editCandidate,setEditCandidate]=useState({name:'Ali'})
  const handleDelete = async (id: string) => {
    setShowLoader(true);
    try {
      const dbRef = ref(db, `recruitment/${id}`);
      await remove(dbRef)
        .then(() => {
          setShowLoader(false);
          setShowToast(true);
          setToastMessage("Candidate Deleted Successfully!");
        })
        .catch((error) => {
          setShowLoader(false);
          console.error("Error Deleting Candidate:", error);
          setShowToast(true);
          setToastMessage(`Error Deleting Candidate: ${error}`);
        });
    } catch (error) {
      setShowLoader(false);
      setShowToast(true);
      setToastMessage("Deletion Failed!");
    }
  };
  
  const handleAddEntry = async () => {
    if(!selectedEmployee) {
      setDilogueMessage("Please select the Employee")
      setShowDilogue(true);
      return
    }
    
   
    if (feedback && currentCandidateId) {
      const today = new Date().toISOString().split('T')[0];
      const givenBy = selectedEmployee?.title

      const newFeedback = {
        feedback,
        givenBy
      };

      // Push a new feedback under the specific date
      const newFeedbackRef = push(ref(db, `recruitment/${currentCandidateId}/feedbacks/${today}`));
      await set(newFeedbackRef, newFeedback);

      setDilogueMessage("Feedback added successfully");
      setShowDilogue(true);
      setFeedback('');
      setIsVisible(false);

    }
    
  };

  const viewFeedback = async (candidateId) => {
    const candidateRef = ref(db, `recruitment/${candidateId}/feedbacks`);
    const snapshot = await get(candidateRef);
    if (snapshot.exists()) {
      const feedbackData = snapshot.val();
      const feedbackArray = Object.keys(feedbackData).map(date => ({
        date,
        feedbacks: Object.entries(feedbackData[date]).map(([key, value]) => ({
          id: key,
          ...value,
        })),
      }));
      setCurrentFeedbacks(feedbackArray);
      setCurrentCandidateId(candidateId)
      setViewFeedbackModalVisibal(true);
    }
    else {
      setDilogueMessage("No feedback is added")
      setShowDilogue(true)
    }
  };
  
  const handleDeleteFeedback = async (date, feedbackId) => {
    if (currentCandidateId ) {
      const feedbackRef = ref(db, `recruitment/${currentCandidateId}/feedbacks/${date}/${feedbackId}`);
      await remove(feedbackRef);

      // Update the feedbacks state after deletion
      const updatedFeedbacks: any = currentFeedbacks.map(fb => {
        if (fb.date === date) {
          return {
            ...fb,
            feedbacks: fb.feedbacks.filter(feedback => feedback.id !== feedbackId),
          };
        }
        return fb;
      }).filter(fb => fb.feedbacks.length > 0); // Remove date if no feedbacks left

      setCurrentFeedbacks(updatedFeedbacks);
    setFeedbackDate("")
  setFeedbackId("")

    }

  };
 
const feedbackDeleteConfarmation=(date,id)=>{
 
  setFeedbackDate(date)
  setFeedbackId(id)
   setDilogueMessage("Are you sure to Delete Feedback");
  setConfirmDilogueVisibal(true);
}

const fetchUsersNameData = async () => {
  try {
    const dbRef = ref(db, `profile`);
    await get(dbRef)
      .then((snapshot) => {
        if (snapshot.exists()) {
          const userFetchedData = snapshot.val();
          const usersNameData:any = [];
          Object.keys(userFetchedData).forEach((userID) => {
            var userObj = userFetchedData[userID];
            if (userObj.userTypeId !== 1 && userObj.employmentStatus === "Active") {
              userObj.id = userID;
              userObj.title = userObj.firstName + " " + userObj.lastName
              usersNameData.push(userObj)
              // setUserList(prevUserList => [...prevUserList, userObj]);
            }
          });
          console.log("userList", usersNameData);
          setUserList(usersNameData)
        } else {
          console.log("No data available for the specified date.");
        }
      })
      .catch((error) => {
        console.error("Failed to retrieve data:", error);
      });
  } catch (error: any) {
    console.error("Error reading data:", error.message);
  }
};

  return (
    <div style={{ display: "flex", flexDirection: "row", height: "100%" }}>
      <Menu />
      <div ref={scrollContainerRef} style={{ overflowX: "hidden", width: screenWidth < MOBILE_VIEW_WIDTH ? "90%" : "100%", padding: '0px 0px 0px 20px' }}>
        <div style={{ width: screenWidth < MOBILE_VIEW_WIDTH ? "100%" : "97%", fontFamily: "Outfit", }}>
          <div style={{
            textAlign: 'center', width: '100%', fontSize: 36, fontWeight: '700', marginTop: screenWidth > MOBILE_VIEW_WIDTH ? 20 : 10,
            color: "#2F4858",
          }}>
            Recruitment
          </div>
          <button
            style={{...styles.addButton,cursor:'pointer'}}
            onClick={() => setOpenForm(true)}>
            <Text style={styles.addCandidateButtonText}>Add New</Text>
          </button>
          {openForm &&!editMode&& <AddCandidateForm openForm={true} editMode={false} handleFormClose={onCandidateFormClose}
          handleFormSubmit={onCandidateFormSubmit}
            candidates={candidates}
          />}
       {openForm &&editMode&&
        <AddCandidateForm openForm={true} handleFormClose={onCandidateFormClose}
        editMode={true}
          handleFormSubmit={onCandidateFormSubmit}
            candidates={editCandidate}
          />
        }

          <div>
            <h2>Candidates List</h2>

            <div
              style={{
                display: "flex",
                flexDirection: screenWidth <= MOBILE_VIEW_WIDTH ? 'column' : 'row',
                flexWrap: "wrap",
                marginTop: 20,
                marginBottom: 20,
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  marginRight: screenWidth < MOBILE_VIEW_WIDTH ? 0 : 20,
                  flex: 1,
                  width: screenWidth < MOBILE_VIEW_WIDTH ? "100%" : "auto",
                  
                }}
              >
                <label style={styles.filterLabel} id="experience">
                  Experience (years):
                </label>
                <input
                  style={styles.filterInput}
                  min={0}
                  type="number"
                  name="experience"
                  id="experience"
                  value={filters.experience}
                  onChange={handleInputChange}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  marginRight: screenWidth < MOBILE_VIEW_WIDTH ? 0 : 20,
                  flex: 1,
                  width: screenWidth < MOBILE_VIEW_WIDTH ? "100%" : "auto",
                  
                }}
              >
                <label style={styles.filterLabel} id="currentSalaryMin">
                  Current Salary Min:
                </label>
                <input
                  style={styles.filterInput}
                  type="number"
                  min={0}
                  name="currentSalaryMin"
                  id="currentSalaryMin"
                  value={filters.currentSalaryMin}
                  onChange={handleInputChange}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  marginRight: screenWidth < MOBILE_VIEW_WIDTH ? 0 : 20,
                  flex: 1,
                  width: screenWidth < MOBILE_VIEW_WIDTH ? "100%" : "auto",
                  
                }}
              >
                <label style={styles.filterLabel} id="currentSalaryMax">
                  Current Salary Max:
                </label>
                <input
                  style={styles.filterInput}
                  type="number"
                  min={0}
                  name="currentSalaryMax"
                  id="currentSalaryMax"
                  value={filters.currentSalaryMax}
                  onChange={handleInputChange}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  width: screenWidth < MOBILE_VIEW_WIDTH ? "100%" : "auto",
                  justifyContent:"end"
                }}
              >
                <label style={{ height: "20px" }}></label>
                <button
                  style={{
                    backgroundColor: '#2F4858',
                    borderRadius: 100,
                    width: screenWidth <= MOBILE_VIEW_WIDTH ? "auto" : "100px",
                    height: "40px",
                    outline: "none",
                    border: "none",
                    color: "#FFFFFF",
                    cursor: "pointer",
                  }}
                  onClick={handleApplyFilters}
                >
                  Apply
                </button>
              </div>
            </div>

            <div style={{ overflow: "scroll" }}>
              <table style={{ marginBottom: 20, borderCollapse: 'collapse', backgroundColor: '#FFFFFF66', width: '100%' }}>
                <thead style={{ fontSize: 14 }}>
                  <tr style={{ backgroundColor: "#2F4858", color: "#FFFFFF" }}>       
             {screenWidth>=MOBILE_VIEW_WIDTH&& <th style={{ border: '1px solid black', padding: '15px' }}>Name</th>}
                    <th style={{ border: '1px solid black', padding: '15px' }}>Email</th>
                    {screenWidth >= MOBILE_VIEW_WIDTH && (
                      <>
                        <th style={{ border: '1px solid black', padding: '15px', textWrap:"nowrap" }}>Current Salary</th>
                        <th style={{ border: '1px solid black', padding: '15px', textWrap:"nowrap" }}>Expected Salary</th>
                        <th style={{ border: '1px solid black', padding: '15px' }}>Experience</th>
                        <th style={{ border: '1px solid black', padding: '15px' }}>Availability</th>
                        <th style={{ border: '1px solid black', padding: '15px' }}>Other Details</th>
                        <th style={{ border: '1px solid black', padding: '8px' }}>Feedback</th>
                        <th style={{ border: '1px solid black', padding: '8px' }}>Action</th>
                      </>
                    )}
                    <th style={{ border: '1px solid black', padding: '15px' }}>Resume</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredCandidates.map((candidate, index) => (
                    <tr key={candidate.id} style={{ backgroundColor: index % 2 === 1 ? "#2F48581A" : undefined }}>
                   {screenWidth>=MOBILE_VIEW_WIDTH&&   <td style={{ borderRight: '1px solid #2F485880', padding: '15px' }}>{candidate.name}</td>}
                      <td style={{ borderRight: "1px solid #2F485880", padding: '15px' }}>{candidate.email}</td>
                      {screenWidth >= MOBILE_VIEW_WIDTH && (
                        <>
                          <td style={{ borderLeft: '1px solid #2F485880', padding: '15px', textAlign:"center" }}>{candidate.currentSalary ||''}</td>
                          <td style={{ borderLeft: '1px solid #2F485880', padding: '15px', textAlign:"center" }}>{candidate.expectedSalary ||''}</td>
                          <td style={{ borderLeft: '1px solid #2F485880', padding: '15px', textAlign:"center" }}>{candidate.experience || ''}</td>
                          <td style={{ borderLeft: '1px solid #2F485880', padding: '15px', textWrap:"nowrap", textAlign:"center"  }}>{formatDate(candidate.availability, "DD-MM-YYYY") || ''}</td>
                          <td style={{ borderLeft: '1px solid #2F485880', padding: '15px' }}>{candidate.otherDetails || ''}</td>
                          <td style={{ border: '1px solid #2F485880', padding: '15spx' }}>
                            <div style={{ display: "flex", flexDirection: "column" }}>
                              <button style={{ ...styles.feedbackButton, backgroundColor: "#2F4858", color: "#ffffff", height: "30px", width: "130px" }} onClick={() => { setIsVisible(true); setCurrentCandidateId(candidate.id); }}>Add feedback</button>
                              <button style={{ ...styles.feedbackButton, backgroundColor: "#2F4858", color: "#ffffff", height: "30px", width: "130px" }} onClick={() => viewFeedback(candidate.id)}>View Feedback</button>
                            </div>   </td>
                            <td >
                              <div style={{height:'100%',display:'flex',flexDirection:'row',justifyContent:'space-evenly',alignItems:'center'}}>
                              <BsPenFill  
                                style={{cursor:'pointer'}}
                                onClick={()=>{
                                  setEditCandidate(candidate)              
                          setEditMode(true)
                          setOpenForm(true)
                                }}
                              />
                              {/* <BsTrashFill  style={{cursor:'pointer'}} onClick={()=>handleDelete(candidate.id)}/> */}
                              </div>
                              </td>
                        </>
                      )}
                      <td style={{ borderLeft: '1px solid #2F485880', padding: '15px', textAlign: 'center' }}>
                        <a href={candidate.fileUrl} target='_blank' download={candidate.fileName} style={{ padding: '5px' }}>
                          <BsFilePdf style={{ color: 'red' }} />
                        </a>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

          </div>
        </div>
        <Dialog
          message={toastMessage}
          isDialogVisible={showToast}
          handleDialogConfirm={() => {
            setShowToast(false)
          }}
        />
        <Dialog
          message={dilogueMessage}
          onDialogClose={() => setShowDilogue(false)}
          isDialogVisible={showDilogue}
          title="Feedback"
        />
         <Dialog
         confirm={true}
          message={dilogueMessage}
          onDialogClose={() => {setConfirmDilogueVisibal(false)}}
          isDialogVisible={confirmDilogeVisibal}
          handleDialogConfirm={() => {handleDeleteFeedback(feedbackDate,feedbackID);setConfirmDilogueVisibal(false)}}
        />
        {viewFeedbackModalVisibal&&
        
          <View style={{...styles.ViewFeedbackModalContainer,left:screenWidth<MOBILE_VIEW_WIDTH?"10%":"35%",width:screenWidth<MOBILE_VIEW_WIDTH?"80%":"35%"}}>
            <View style={{ display: "flex", flexDirection: "row", justifyContent: "center" }}>
              <Text style={styles.ViewfeedbackModalHeading}>Feedbacks</Text>
          
              <img src={closeIcon} alt="Close"    style={{ right: 10, position: "absolute", top: 5, cursor: "pointer", width:13,height:13 }}     onClick={() => setViewFeedbackModalVisibal(false)}/>

            </View>
            <ScrollView >

              {currentFeedbacks.map((fb, index) => (
                <View key={index} style={{ marginBottom: 10 }}>
                  <Text style={{ textAlign: 'center', fontSize: 16, fontWeight: "600", color: "#2F4858", marginTop: 10 }}>{fb.date}</Text>
                  {fb.feedbacks.map((feedback, feedbackIndex) => (
                    <View key={feedback.id} style={{
                      display: 'flex', flexDirection: "column", backgroundColor: '#2F4858', paddingHorizontal: "10px", paddingVertical: "5px", marginTop: "5px",
                        position:"relative",
                      borderRadius: 10,
                    }}>
                      <Text style={{ color: '#ffffff', fontSize: "16px", fontWeight: "600" }}>Given By: {feedback.givenBy}</Text>
                      <Text style={{
                        color: '#ffffff',
                        fontSize: "16px",
                        fontWeight: "600",
                        paddingLeft: 10,
                        textAlign:"justify"
                      }}>{feedback.feedback}</Text>
                       
              <img src={closeIcon} alt="Close"    style={{ right: 10, position: "absolute", top: 10, cursor: "pointer", width:10,height:10,  filter: "invert(100%) sepia(0%) saturate(0%) hue-rotate(180deg) brightness(100%) contrast(100%)"}}       onClick={() => {  
    feedbackDeleteConfarmation(fb.date, feedback.id)
   
  }}/>

                      {/* <button style={styles.feedbackButton} onClick={() => handleDeleteFeedback(fb.date, feedback.id)}>Delete {feedbackIndex + 1}</button> */}
                    </View>
                  ))}
                </View>
              ))}
            </ScrollView>
          </View>
        }
       {isVisible&&
          <View style={{...styles.addFeedbackModalContainer,left:screenWidth<MOBILE_VIEW_WIDTH?"10%":"40%",width:screenWidth<MOBILE_VIEW_WIDTH?"80%":"25%"}}>
           
              <View style={{ display: "flex", flexDirection: "row", justifyContent: "center" }}>
                <Text style={styles.addFeedbackModalHeading}>Add FeedBack</Text>
               
              <img src={closeIcon} alt="Close"    style={{ right: 10, position: "absolute", top: 5, cursor: "pointer", width:13,height:13 }}              onClick={() => setIsVisible(false)}/>

              </View>
              <ScrollView >
              <View style={styles.inputContainer}>
                <Text style={[styles.AddFeedbackModalLabel, { marginTop: 3 }]}>Given By</Text>
                <DropDownField
                  isObjectList={true}
                  value={selectedEmployee?.title}
                  placeholder="Select Employee"
                  bodyStyle={{ marginHorizontal: 0 , marginBottom: 15}}
                  options={userList}
                  onChangeText={(selectedObj) => setSelectedEmployee(selectedObj)}
                  label="Employee"
                />
              </View>
              <TextInput
                multiline={true}
                numberOfLines={4} // You can adjust the number of lines as needed
                style={styles.AddfeedbackModalTextArea} // Define a style for the text area
                placeholder="Enter feedback"
                placeholderTextColor={"#333333"}
                value={feedback}
                onChangeText={(text) => setFeedback(text)}
              />
            </ScrollView>

              <button
                onClick={handleAddEntry}
                style={{ ...styles.addButton, width: "110px", marginTop: 30, cursor: "pointer" }}
              >
                Add
              </button>
          </View>
        }
      </div>
      <Dialog
        message={toastMessage}
        isDialogVisible={showToast}
        onDialogClose={() => {
          setShowToast(false)
          if(toastMessage.includes('Candidate Deleted Successfully!'))
            fetchCandidates()
        }
        }
        title="Candidate Deleted"
        confirmText="Close"
      />
      {showLoader && <Loader />}
    </div>
  )
};




const styles = StyleSheetRW.create(() => ({
  addFeedbackModalContainer: {
    position: "absolute",
    top: "30%",
    bottom: "40%",
    padding: 20,
    display: "flex",
    flexDirection: "column",
    backgroundColor: "#ffffff",
    borderRadius: 24,
    opacity: 1,
    transition: "opacity 0.3s ease",
    zIndex: 1,
    boxShadow: "0 2px 5px rgba(0, 0, 0, 0.2)",
    width: "299px",
    alignSelf: "center",
  },
  ViewFeedbackModalContainer: {
    position: "absolute",
    top: "20%",
    bottom: "20%",
    alignSelf: "center",

    padding: 20,
    display: "flex",
    flexDirection: "column",
    backgroundColor: "#ffffff",
    borderRadius: 24,
    opacity: 1,
    transition: "opacity 0.3s ease",
    zIndex: 100,
    boxShadow: "0 2px 5px rgba(0, 0, 0, 0.2)",
    width: "40%",
    height: "500px"
  },
  addFeedbackModalHeading: {
    fontFamily: "Outfit",
    fontSize: 20,
    fontWeight: "bold",
    textAlign: "center",
    color: "#2F4858",
  },
  feedbackButton: {
    backgroundColor: "#ffffff",
    alignSelf: "center",
    borderRadius: 100,
    color: "#2F4858",
    fontWeight: "300",
    textAlign: "center",
    borderWidth: 0,
    width: "80px",
    height: "30px",
    margin: 5,
    cursor:"pointer"
  },
  AddfeedbackModalTextArea: {
    height: 100, // Set the desired height of the text area
    borderRadius: 10,
    paddingHorizontal: 10,
    paddingVertical: 10,
    backgroundColor: "#0000000D",
    marginTop: 3,
  },
  AddFeedbackModalLabel: {
    fontFamily: "Outfit",
    fontSize: 14,
    fontWeight: "600",
    lineHeight: 17.64,
    textAlign: "left",
    marginTop: 10,
    marginBottom: 5,
    color: "#333333",
  },
  input: {
    height: 50,
    borderRadius: 10,
    paddingHorizontal: 10,
    backgroundColor: "#0000000D",
    marginTop: 3,
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  addButton: {
    width: 147,
    backgroundColor: '#2F4858',
    paddingVertical: 10,
    paddingHorizontal: 20,
    borderRadius: 100,
    color: "white",
    fontWeight: "300",
    textAlign: "center",
    borderWidth: 0,
    alignSelf:"center",
    height: "38px",
    
  },
  buttoneStyle: {
    backgroundColor: "#8c9ea2",
    borderRadius: 99,
    fontWeight: "lighter",
    fontSize: "14px",
    color: "white",
    width: "110px",
    height: "37px",
    border: "0",
  },
  button: {
    backgroundColor: "#2F4858",
    alignSelf: "center",
    borderRadius: 100,
    color: "white",
    fontWeight: "300",
    textAlign: "center",
    borderWidth: 0,
    width: "80px",
    height: "30px",
  },
  container: {
    flex: 1,
    width: "100%",
    height: "100%",
  },
  heading: {
    fontFamily: "Outfit",
    fontSize: 32,
    fontWeight: 'bold',
    color: "#2F4858",
    width: '100%',
    textAlign: 'center'
  },
  ViewfeedbackModalHeading: {
    fontFamily: "Outfit",
    fontSize: 32,
    fontWeight: '700',
    color: "#2F4858",
    textAlign: 'left'
  },
  subheading: {
    fontFamily: 'Outfit',
    fontSize: 18,
    fontWeight: 'bold',
    color: '#2F4858',
    marginTop: 10,
  },
  form: {
    width: '100%',
    height: '100%',
    marginTop: 20,
  },
  row: {
    justifyContent: 'space-between',
    marginBottom: 10,
    gap: 20
  },
  inputContainer: {
    flex: 1,
    marginRight: 5,
  },
  addCandidateButtonText: {
    color: 'white',
    fontWeight: "400",
    textAlign: "center",
  },
  line: {
    borderBottomWidth: 1,
    borderColor: '#2F4858',
    marginBottom: 10,
  },
  container2: {
    padding: 20,
    display: "flex",
    flexDirection: "column",
    backgroundColor: "#ffffff",
    borderRadius: 24,
    boxShadow: "0 2px 5px rgba(0, 0, 0, 0.2)",
    alignSelf: "center",
    gap: 10
  },
  filterLabel: {
    fontFamily: 'Outfit',
    fontSize: 16,
    fontWeight: '600',
    color: '#333333',
    marginBottom: 5,
    marginTop: 10,
  },
  filterInput: {
    backgroundColor: "#0000000D",
    border: "none",
    height: 20,
    borderRadius: 10,
    padding: 10,
    fontFamily: 'Outfit',
    fontSize: 14,
    fontWeight: '600',
    color: '#333333',
    outline: "none",
  },

}));

export default RecruitmentScreen;
